<script>
    import TextField from "@itslearning/prometheus/assets/inputs/TextField/v1/TextField.svelte";
    import Button from "@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte";
    import Switch from "@itslearning/prometheus/assets/inputs/Switch/v1/Switch.svelte";
    import Banner from "@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte";
    import { saveSurvey, hasRespondents } from "../api";
    import { survey } from "../stores";
    import { txt } from "../i18n/i18n";
    import { navigateToViewSurveyPage, navigateToQuestionListPage } from "../navigation";
    import { stripHtml } from "../helpers";
    import { onMount } from "svelte";

    let errorFromApi = false;
    let message = { text: txt('Unknown_error'), type: 'warning' };
    let isSaving = false;
    let respondentsStatus = undefined;

    export let anonymous = true;
    export let openExtern = false;
    export let introduction = '';

    $: hasInstanceResponse = respondentsStatus && respondentsStatus.hasInstanceResponse;
    $: disableAnonymousSwitch = $survey.isCreated && (!respondentsStatus || hasInstanceResponse);
    $: disableExternSwitch = $survey.isCreated && $survey.respondentType === 1 && (!respondentsStatus || hasInstanceResponse);
    
    onMount(async () => {
        if(!$survey.isCreated) {
            return;
        }
        introduction = $survey.description;
        if ($survey.hasHtml) {
            introduction = stripHtml(introduction, true);
        }
        anonymous = $survey.respondentType > 1;
        openExtern = $survey.respondentType === 3;
        await getRespondentStatus();
    });

    async function getRespondentStatus() {
        try {
            respondentsStatus = await hasRespondents();
        } catch {
            errorFromApi = true;
        }
    }

    async function save() {
        try {
            if(isSaving){
                return;
            }
            isSaving= true;
            let respondentType = 1;
            if (anonymous) {
                openExtern ? (respondentType = 3) : (respondentType = 2);
            }
            let shouldNavigateToQuestionPage = !$survey.isCreated
            await saveSurvey(introduction, respondentType);
            survey.update((currentSurvey) => {
                currentSurvey.description = introduction;
                currentSurvey.respondentType = respondentType;
                currentSurvey.isCreated = true;
                currentSurvey.hasHtml = false;
                return currentSurvey;
            });
            errorFromApi = false;
            shouldNavigateToQuestionPage ? navigateToQuestionListPage() : navigateToViewSurveyPage();
        } catch {
            errorFromApi = true;
        }
        isSaving = false;
    }

    function handleAnonymous({ checked }) {
        if (checked) {
            openExtern = false;
        }
    }

    function handleExternAnonymous({ checked }) {
        if (!checked) {
            anonymous = true;
        }
    }
</script>

<Banner
    type={message.type}
    text={message.text}
    close={txt('Close')}
    visible={errorFromApi}
/>
{#if hasInstanceResponse}
    <Banner type="info" text={txt('Edit_settings_info')} visible="{true}" closable={true} close={txt('Close')}/>
{/if}
{#if $survey.hasHtml}
    <Banner visible="true" type="warning" text="{txt('Imported_rich_text_edit_warning')}" closable={false} />
{/if}
<div class="flow edit-survey">
    <TextField
        disabled={errorFromApi}
        type="area"
        maxlength="65535"
        rows="10"
        label={txt('Introduction')}
        bind:value={introduction}
    />
    <fieldset class="flow">
        <legend>{txt('Survey_type')}</legend>
        <Switch
            label={txt('Anonymous_responses')}
            name="AnonymousRespondents"
            bind:checked={anonymous}
            on:click={(e) => handleAnonymous(e.detail)}
            disabled={disableAnonymousSwitch}
        />
        <Switch
            label={txt('External_survey')}
            name="OpenExtern"
            bind:checked={openExtern}
            on:click={(e) => handleExternAnonymous(e.detail)}
            disabled={disableExternSwitch}
        />
    </fieldset>
    <div class="footer-actions">
        <div class="footer-actions-left">
            <Button
                text={txt('Save')}
                htmlType="button"
                type="primary"
                on:click={save}
                loading={isSaving}
            />
            {#if errorFromApi || $survey.isCreated}
                <Button
                    text={txt('Cancel')}
                    htmlType="button"
                    type="secondary"
                    on:click={navigateToViewSurveyPage}
                />
            {/if}
        </div>
    </div>
</div>